import { FORMAT_NUMBER } from '@/utils'

export default FORMAT_NUMBER
